import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import ArrowUpIcon from '@atlaskit/icon/core/arrow-up';

const IconButtonRovoExample = (): React.JSX.Element => {
	return <IconButton appearance="rovo" icon={ArrowUpIcon} label="Ask Rovo" />;
};

export default IconButtonRovoExample;
